import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { AdminService } from '../admin.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { XlsxService } from 'src/app/shared/services/xlsx.service';
import { CompanyModel } from 'src/app/core/models/CompanyModel';
import { BlockModel } from 'src/app/core/models/BlockModel';
import { Constants } from 'src/app/constants/constants';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzCheckboxOption } from 'ng-zorro-antd/checkbox';
import { ApplicationRole, ApplicationRoleMapping } from 'src/app/core/models/ApplicationRole';

@Component({
  selector: 'app-manage-user',
  standalone: false,
  templateUrl: './manage-user.component.html',
  styleUrl: './manage-user.component.less'
})
export class ManageUserComponent implements OnInit {

  editUserForm!: FormGroup; // Reactive form instance
  applicationRoles = Object.values(ApplicationRole).filter(value => typeof value === 'number');
  currentUser: User = new User();
  userMaster: RegisteredUserModel[] = [];
  filteredUserMaster: RegisteredUserModel[] = [];
  companyMaster: any[] = [];
  blockMaster: any[] = [];
  isVisible = false;
  showTableLoader = false;
  showEditUserModal: boolean = false;

  selectedUser: RegisteredUserModel = new RegisteredUserModel();
  editSelectedUser: RegisteredUserModel = new RegisteredUserModel();

  checkboxOptions: NzCheckboxOption[] = [];
  selectedRoles: number[] = []; // To store selected roles
  internalRoles: any[] = [];
  partnerRoles: any[] = [];
  roles: any[] = [];
  displayErrorMsg = false;
  errorMsg = "";

  searchText: string = "";
  exportData: { Title: string; Data: { "User Name": string; Email: string; CAI: string; Roles: string; Company: string; Block: string; Status: string; }[]; Headers: string[]; }[] = [];
  constructor(private router: Router,
    private userService: UserService,
    private adminService: AdminService,
    private modalService: NzModalService,
    private dbMasterService: DbMasterService,
    private messageService: NzMessageService,
    public xlxsService: XlsxService,
    private fb: FormBuilder,
  ) {

  }
  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    if (this.currentUser.IsRFCAdmin) {
      this.initialiseForm();
      this.getAllRegisteredUser();
    }
    else {
      this.router.navigate(['/unauthorize']);
    }
  }
  initialiseForm() {
    this.editUserForm = this.fb.group({
      company: ['', !this.editSelectedUser.Is_Partner ? null : Validators.required],
      block: ['', !this.editSelectedUser.Is_Partner ? null : Validators.required], // Block dropdown
      applicationRoles: this.fb.array([]) // Initialize as FormArray
    });
  }
  getAllRegisteredUser() {
    this.showTableLoader = true;
    this.adminService.getAllRegisteredUsers(true).subscribe((response: any) => {
      this.userMaster = response.output as RegisteredUserModel[];
      this.userMaster.forEach(function (element) {
        element.Status = element["Active"] ? "Active" : "Inactive";
        element.CompanyName = element.Company.Company_Name;
        element.BlockName = element.Block.Block_Name;
      });
      this.showTableLoader = false;
      this.filteredUserMaster = [...this.userMaster];
      this.onSearch();
      this.getApplicationRoles();
      this.getAllCompanyAndBlock();
    });
  }

  getApplicationRoles() {
    this.dbMasterService.getAllRoles(true).subscribe((resp: any) => {
      this.roles = resp.output;
      this.internalRoles = this.roles.slice(0, 5);
      this.partnerRoles = this.roles.slice(5, 7);
      //this.addCheckboxes(); MANAS_TBD
    });
  }
  getAllCompanyAndBlock() {
    this.adminService.GetAllCompanyAndBlock().subscribe((response: any) => {
      this.companyMaster = response.output.Company.filter((comp: any) => comp.Active) as CompanyModel[];;
      this.blockMaster = response.output.Block as BlockModel[];;
    });
  }
  viewUser(user: RegisteredUserModel) {
    this.isVisible = true;
    this.selectedUser = user;
    //this.setRoles(this.selectedUser);   TBD  
  }
  handleCancel() {
    this.isVisible = false;
  }
  handleCancelEdit() {
    this.showEditUserModal = false;
  }
  onRolesChange(event: any): void {
    // Update the selected roles using the reusable function
    this.updateSelectedRoles(Number(event.target.value), event.target.checked);
  }
  updateSelectedRoles(value: number, isChecked: boolean): void {
    if (isChecked) {
      // Add the role if it is not already in the list
      if (!this.selectedRoles.includes(value)) {
        this.selectedRoles.push(value);
      }
    } else {
      // Remove the role if it exists in the list
      const index = this.selectedRoles.indexOf(value);
      if (index > -1) {
        this.selectedRoles.splice(index, 1);
      }
    }
  }
  openDeactivateModal(user: RegisteredUserModel) {
    this.modalService.confirm({
      nzTitle: 'Confirm !',
      nzWidth: 500,
      nzContent: `Are you sure you want to deactivate this user <b style="color: red;">${user.User_Name}</b> ?`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOnOk: () => {
        this.deactivateUser(user);
      },
      nzCancelText: 'No',
      nzOnCancel: () => {
        console.log('Cancel');
      }
    });
  }
  deactivateUser(user: RegisteredUserModel) {
    var userToBeDeleted = new RegisteredUserModel();
    userToBeDeleted.User_Code = user.User_Code;
    userToBeDeleted.Created_By = this.currentUser.User_Code ?? 0;
    userToBeDeleted.Active = false;
    this.adminService.updateUserStatus(userToBeDeleted).subscribe((response: any) => {
      if (response.result) {
        //user.Active = false;
        //user.Status = "Inactive";
        this.getAllRegisteredUser();
        this.messageService.success("User deactivated successfully!", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
      }
      else {
        this.messageService.error("Error occurred while deactivating user.");
      }
    });
  }
  openReactivateModal(user: RegisteredUserModel) {
    this.modalService.confirm({
      nzTitle: 'Confirm !',
      nzWidth: 500,
      nzContent: `Are you sure you want to reactivate this user <b style="color: red;">${user.User_Name}</b> ?`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOnOk: () => {
        this.reactivateUser(user);
      },
      nzCancelText: 'No',
      nzOnCancel: () => {
        console.log('Cancel');
      }
    });
  }
  reactivateUser(user: RegisteredUserModel) {
    var userToBeActivated = new RegisteredUserModel();
    userToBeActivated.User_Code = user.User_Code;
    userToBeActivated.Created_By = this.currentUser.User_Code ?? 0;
    userToBeActivated.Active = true;
    user.Status = "Active";

    this.adminService.updateUserStatus(userToBeActivated).subscribe((response: any) => {
      if (response.result) {
        this.getAllRegisteredUser();
        this.messageService.success("User reactivated successfully!", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
      }
      else {
        this.messageService.error("Error occurred while reactivating user");
      }
    });
  }
  logReasonForInvalidForm() {
    console.log("Form is invalid. Errors:");
    Object.keys(this.editUserForm.controls).forEach(key => {
      const controlErrors = this.editUserForm.get(key)?.errors;
      if (controlErrors) {
        console.log(`Field: ${key}, Errors:`, controlErrors);
      }
    });
  }
  onSubmitEdit() {
    this.displayErrorMsg = false;
    this.errorMsg = "";
    if (this.editUserForm.valid) {

      this.editSelectedUser.Company.Company_Code = this.editUserForm.get('company')?.value;
      this.editSelectedUser.Block.Block_Code = this.editUserForm.get('block')?.value;
      this.editSelectedUser.ApplicationRoles = this.selectedRoles
      this.editSelectedUser.Created_By = this.currentUser.User_Code ?? 0;

      this.adminService.updateUser(this.editSelectedUser).subscribe((response: any) => {
        if (response.result) {
          if (response.result) {
            this.messageService.success("User Role updated successfully!", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
          }
          else {
            this.messageService.error("Only active users roles can be edited", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
          }

          this.getAllRegisteredUser();
          //this.messageService.success("User updated successfully!", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
          this.showEditUserModal = false;
        }
        else {
          this.messageService.error("Error occurred while updating user.");
        }
      });
    } else {
      this.displayErrorMsg = true;
      this.errorMsg = "Please select company and block.";
    }
  }
  onSearch(): void {
    const searchTextLower = this.searchText.toLowerCase();

    // Only filter if the search text has at least 3 characters
    if (searchTextLower.length >= 3) {
      this.filteredUserMaster = this.userMaster.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTextLower)
        )
      );
    } else {
      // Reset the filtered data to the original data if search text is less than 3 characters
      this.filteredUserMaster = [...this.userMaster];
    }
  }
  openEditUserPopup(user: RegisteredUserModel) {
    this.editSelectedUser = user;

    // Reset the form and clear the FormArray
    this.editUserForm.reset();
    this.applicationRolesArray.clear();

    // Patch the form values
    this.patchFormValuesAndValidations();

    // Map roles to checkboxes
    this.mapApplicationRolesToCheckboxOptions();


    this.showEditUserModal = true;
  }
  patchFormValuesAndValidations() {
    this.editUserForm.patchValue({
      company: this.editSelectedUser.Company?.Company_Code,
      block: this.editSelectedUser.Block?.Block_Code
    });

    // Enforce mandatory fields if Is_Partner is true
    if (this.editSelectedUser.Is_Partner) {
      this.editUserForm.get('company')?.setValidators(Validators.required);
      this.editUserForm.get('block')?.setValidators(Validators.required);
    } else {
      this.editUserForm.get('company')?.clearValidators();
      this.editUserForm.get('block')?.clearValidators();
    }
    // Update the validity of the form controls
    this.editUserForm.get('company')?.updateValueAndValidity();
    this.editUserForm.get('block')?.updateValueAndValidity();

  }
  mapApplicationRolesToCheckboxOptions(): void {
    // Map ApplicationRole to checkboxOptions
    this.selectedRoles = this.editSelectedUser.ApplicationRoles.map(role => role as number); // Convert to number array
    var tempRoles = this.editSelectedUser.Is_Partner ? this.applicationRoles.slice(5, 7) : this.applicationRoles.slice(0, 5);
    this.checkboxOptions = tempRoles.map(role => ({
      label: ApplicationRoleMapping[role as ApplicationRole], // Map role to its label
      value: role
    }));

    // Populate the FormArray with controls for each role
    this.checkboxOptions.forEach((checkbox: any) => {
      let isChecked = this.editSelectedUser.ApplicationRoles.some(option => option === checkbox.value);
      this.applicationRolesArray.push(this.fb.control(isChecked)); // Add a control for each checkbox
    });

  }

  get applicationRolesArray(): FormArray {
    return this.editUserForm.get('applicationRoles') as FormArray;
  }
  exportToExcel() {
    this.exportData = [];
    let exportData = [];
    let headers = ["User Name",
      "Email",
      "CAI",
      "Roles",
      "Company",
      "Block",
      "Status"
    ];

    exportData = this.filteredUserMaster.map(function (item) {
      return {
        "User Name": item.User_Name,
        "Email": item.Email,
        "CAI": item.CAI,
        "Roles": item.Roles,
        "Company": item.Company.Company_Name,
        "Block": item.Block.Block_Name,
        "Status": item.Status
      };
    });

    this.exportData.push({ Title: 'User_Details', Data: exportData, Headers: headers });
    this.xlxsService.export(this.exportData, "User_Details");
  }
  listOfColumn = [
    {
      title: 'User Name',
      compare: (a: RegisteredUserModel, b: RegisteredUserModel) => (a.User_Name || '').localeCompare(b.User_Name || ''),
      priority: 3,
      allowSorting: true
    },
    {
      title: 'Email',
      compare: (a: RegisteredUserModel, b: RegisteredUserModel) => (a.Email || '').localeCompare(b.Email || ''),
      priority: 2,
      allowSorting: true
    },
    {
      title: 'CAI',
      compare: (a: RegisteredUserModel, b: RegisteredUserModel) => (a.CAI || '').localeCompare(b.CAI || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Roles',
      compare: (a: RegisteredUserModel, b: RegisteredUserModel) => (a.Roles || '').localeCompare(b.Roles || ''),
      priority: 1,
      allowSorting: true
    }
    ,
    {
      title: 'Company ',
      compare: (a: RegisteredUserModel, b: RegisteredUserModel) => a.CompanyName.localeCompare(b.CompanyName || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Block',
      compare: (a: RegisteredUserModel, b: RegisteredUserModel) => (a.BlockName || '').localeCompare(b.BlockName || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Status',
      compare: null,
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Action',
      compare: null,
      priority: false,
      allowSorting: false
    }
  ];

}
